import { SortDirectionDto, TaskItemDto } from '@/api/generated';
import {
  CustomTableStateDataModel,
  CustomTableStateModel,
} from '@/components/table/model/CustomTableState.model.ts';
import {
  initialTasksListSearchFormModel,
  TasksListSearchFormModel,
} from '@/views/tasks/list/model/TasksListSearchForm.model.ts';

export interface TasksListTableState extends CustomTableStateModel<
  string,
  TasksListSearchFormModel,
  TaskItemDto
> {
  data: CustomTableStateDataModel<TaskItemDto>;
}

export const initialTasksListTableState: TasksListTableState = {
  data: {
    items: [],
    totalPages: 0,
    totalResults: 0,
  },
  page: 0,
  pageSize: 10,
  params: initialTasksListSearchFormModel,
  sortBy: '',
  sortOrder: SortDirectionDto.Asc,
};
